import React, { useState } from "react";
import { Box, Button, Group, Tooltip } from "@mantine/core";
import { gray, primary } from "../../../constants/color-constants";

interface ButtonGroupProps {
  buttons: string[];
  defaultActive?: string;
  onChange?: (value: string) => void;
  tooltips?: Record<string, string>;
  /** Optional leading icon rendered before the button label. */
  leadingIcons?: Record<string, React.ReactNode>;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  defaultActive,
  onChange,
  tooltips,
  leadingIcons,
}) => {
  const [active, setActive] = useState(defaultActive || buttons[0]);

  const handleClick = (value: string) => {
    setActive(value);
    onChange?.(value);
  };

  return (
    <Group gap={"xs"}>
      {buttons.map((label) => {
        const leadingIcon = leadingIcons?.[label];
        const button = (
          <Button
            size='xs'
            color={primary[5]}
            c={active === label ? "" : gray[8]}
            key={label}
            variant={active === label ? "filled" : "outline"}
            onClick={() => handleClick(label)}
            leftSection={
              leadingIcon ? (
                <Box
                  component='span'
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: 0,
                  }}
                >
                  {leadingIcon}
                </Box>
              ) : undefined
            }
          >
            {label}
          </Button>
        );

        if (tooltips?.[label]) {
          return (
            <Tooltip
              key={label}
              label={tooltips[label]}
              withArrow
              position='top'
              color={gray[8]}
              styles={{ tooltip: { zIndex: 1000 } }}
            >
              {button}
            </Tooltip>
          );
        }

        return button;
      })}
    </Group>
  );
};

export default ButtonGroup;
